"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklyScheduleControlInteractor = void 0;
const components_1 = require("@veeam/components");
require("@veeam/components/lib/SchedulingMatrix/types");
const core_1 = require("@veeam/core");
const CommonScheduleControlInteractor_1 = require("../../CommonScheduleControlInteractor");
const helpers_1 = require("../../helpers");
require("../../models");
require("../../types");
const WeeklyScheduleHarmonizationManager_1 = require("../../WeeklyScheduleHarmonizationManager");
class WeeklyScheduleControlInteractor extends CommonScheduleControlInteractor_1.CommonScheduleControlInteractor {
    constructor(controlModel, texts, dailyRetentionFieldsSettings, retentionFieldsSettings, models, handlers, columns = helpers_1.getWeeklyColumns(texts.matrix)) {
        super(controlModel, texts, columns);
        this.controlModel = controlModel;
        this.texts = texts;
        this.dailyRetentionFieldsSettings = dailyRetentionFieldsSettings;
        this.retentionFieldsSettings = retentionFieldsSettings;
        this.models = models;
        this.handlers = handlers;
        this.columns = columns;
        this.getRows = () => {
            return helpers_1.getCommonScheduleRows(this.controlModel.getValue(), this.texts, this.getScheduleRowsVisibilityData(), false);
        };
        this.isMatrixDisabled = (value) => {
            return this.harmonizationManager.isMatrixColumnSelectable(value);
        };
        this.handleDone = () => {
            this.handlers.onDone(this.controlModel.getValue());
        };
        this.handleCancel = () => {
            if (this.form.hasChanges()) {
                this.handlers.onCancel();
                return;
            }
            this.handlers.onClose();
        };
        this.getFieldTimeOptions = () => {
            return helpers_1.getOptionsList(this.harmonizationManager.getFieldTimeOptions());
        };
        this.isFieldTimeDisabled = () => {
            return this.harmonizationManager.isFieldTimeDisabled();
        };
        this.texts = texts;
        this.controlModel = controlModel;
        this.models = models;
        this.handlers = handlers;
        this.harmonizationManager = new WeeklyScheduleHarmonizationManager_1.WeeklyScheduleHarmonizationManager(this.models.weeklyScheduleModel, this.controlModel, this.models, dailyRetentionFieldsSettings, retentionFieldsSettings);
        this.form = new core_1.Form(this.controlModel, {
            validationSchema: Object.assign(Object.assign({}, CommonScheduleControlInteractor_1.CommonScheduleControlInteractor.getScheduleRowsValidations(this.texts.errorTextFirstScheduleIsRequired, models.dailyScheduleModel.isSecondRowExistingAndEnabled(), models.dailyScheduleModel.isThirdRowExistingAndEnabled(), retentionFieldsSettings.rowFirstFieldCountMin, retentionFieldsSettings.rowFirstFieldCountMax, retentionFieldsSettings.rowSecondFieldCountMin, retentionFieldsSettings.rowSecondFieldCountMax, retentionFieldsSettings.rowThirdFieldCountMin, retentionFieldsSettings.rowThirdFieldCountMax)), { fieldTimeValue: [core_1.required()] }),
        });
        this.scheduleMatrixLegendFooter = components_1.createSchedulingMatrixLegendFooter({
            texts: {
                label: this.texts.matrixFooterSelectModeLabel,
                selectMode: this.texts.matrixFooterSelectModeSelectLabel,
                unselectMode: this.texts.matrixFooterSelectModeUnselectLabel,
            },
        });
        this.fieldTimeComboboxModel = new core_1.Model(this.getFieldTimeOptions());
        this.scheduleRetentionTypeComboboxModel = new core_1.Model(this.getScheduleRetentionTypeOptions());
    }
}
exports.WeeklyScheduleControlInteractor = WeeklyScheduleControlInteractor;
//# sourceMappingURL=WeeklyScheduleControlInteractor.js.map